let settings = require( process.env.VUE_APP_CONFIG_ROOT + '/settings' );

if (window._TRUE_PLM_OVERRIDE_CONFIG){
    settings = Object.assign(settings||{}, window._TRUE_PLM_OVERRIDE_CONFIG);
}

export default settings;